import { Box, Divider, Flex, Text } from '@modusign/design-system';
import moment from 'moment';

import DefaultBadge from '@app/features/addressBook/components/ContactInputForm/DefaultBadge';
import Contact from '@app/features/addressBook/types/Contact';
import { getBizNumberFormat, getFormattedSouthKoreaPhoneNumber } from '@app/libs/inputFormat';

interface ContactInfoProps extends Contact {}
export default function ContactInfo({
  bizNumber,
  companyName,
  defaultForwardingMethod,
  departmentPosition,
  email,
  description,
  name,
  phoneNumber,
  createdAt,
  updatedAt,
}: ContactInfoProps) {
  const hasAdditionalInformation = !!(bizNumber || companyName || departmentPosition);

  return (
    <Box mb={4}>
      <Flex gap={4} justifyContent="flex-start" px={4}>
        <Box fontWeight="medium" minWidth="100px">
          이름
        </Box>
        <Box>{name}</Box>
      </Flex>
      <Divider my={6} />
      <Box fontWeight="medium" mb={6} px={4}>
        전자계약 수신처
      </Box>
      {phoneNumber && (
        <Flex gap={4} justifyContent="flex-start" mb={6} px={4}>
          <Box color="textNeutralLight" minWidth="100px">
            휴대폰
            {defaultForwardingMethod === 'KAKAO' && (
              <Box as="span" ml={2}>
                <DefaultBadge />
              </Box>
            )}
          </Box>
          <Box>{getFormattedSouthKoreaPhoneNumber(phoneNumber ?? '')}</Box>
        </Flex>
      )}
      {email && (
        <Flex gap={4} justifyContent="flex-start" px={4}>
          <Box color="textNeutralLight" minWidth="100px">
            이메일
            {defaultForwardingMethod === 'EMAIL' && (
              <Box as="span" ml={2}>
                <DefaultBadge />
              </Box>
            )}
          </Box>
          <Box>{email}</Box>
        </Flex>
      )}
      {description && (
        <>
          <Divider my={6} />
          <Flex gap={4} justifyContent="flex-start" px={4}>
            <Box fontWeight="medium" minWidth="100px">
              설명
            </Box>
            <Text>{description}</Text>
          </Flex>
        </>
      )}
      {hasAdditionalInformation && (
        <>
          <Divider my={6} />
          <Box fontWeight="medium" mb={6} px={4}>
            부가 정보
          </Box>
          {companyName && (
            <Flex gap={4} justifyContent="flex-start" mb={6} px={4}>
              <Box color="textNeutralLight" minWidth="100px">
                회사 또는 단체명
              </Box>
              <Box>{companyName}</Box>
            </Flex>
          )}
          {departmentPosition && (
            <Flex gap={4} justifyContent="flex-start" mb={6} px={4}>
              <Box color="textNeutralLight" minWidth="100px">
                직급 또는 직책
              </Box>
              <Box>{departmentPosition}</Box>
            </Flex>
          )}
          {bizNumber && (
            <Flex gap={4} justifyContent="flex-start" mb={6} px={4}>
              <Box color="textNeutralLight" minWidth="100px">
                사업자등록번호
              </Box>
              <Box>{getBizNumberFormat(bizNumber)}</Box>
            </Flex>
          )}
        </>
      )}
      <Divider my={6} />
      <Box backgroundColor="boxBackgroundNeutralSlightlyLight" borderRadius="3px" p={5}>
        <Text as="p" color="textNeutralLight" fontSize="xs" mb={2}>
          생성일 : {moment(createdAt).format('YYYY. MM. DD')}
        </Text>
        <Text as="p" color="textNeutralLight" fontSize="xs">
          최근 수정일 : {moment(updatedAt).format('YYYY. MM. DD')}
        </Text>
      </Box>
    </Box>
  );
}
